// extracted by mini-css-extract-plugin
export default {"entry":"history_entry___entry___d516054f","entryContent":"history_entry___entryContent___b0b08391","title":"history_entry___title___dc77ff3e"};